import { MediaMatcher } from '@angular/cdk/layout';
import { Platform } from '@angular/cdk/platform';
import { Directive, ElementRef, EventEmitter, Output, OnInit, HostListener, Input, AfterViewInit, OnDestroy } from '@angular/core';
import { Subject, delay, filter } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';

/**
 * Directive to check if an element is in the viewport
 * @Selector isInViewport : element to check
 * @Params threshold : 0.5 or [0.5,0.5] for multiple values to set a distance between the element and the top of the viewport
 * @Event isInViewport emitted when the element is in the viewport
 * Usage : 
 * <div isInViewport (isInViewport)="onIsInViewport($event) [threshold]="0.5"></div>
 * 
 */

@Directive({
  selector: '[isInViewport]'
})
export class IsInViewportDirective implements OnInit {

  
  @Output() isInViewport: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() threshold: number | number[] = 1;// Percentuale decimale da 0 a 1 di distanza dal top di pagina
  constructor(private elementRef: ElementRef,
    private deviceService: DeviceService,
  ) {
   
    this.isMobile = this.deviceService.is_mobile();
   }
  private observer!: IntersectionObserver;
 private isMobile:boolean = false;
  ngOnInit() {
   
    if(this.isMobile){
      this.isInViewport.emit(true);
      return;
    }
    this.observer = new IntersectionObserver(([entry]) => {
      this.isInViewport.emit(entry.isIntersecting);
    }, { root:null,
        rootMargin: '0px',
        threshold: this.threshold
      });

    this.observer.observe(this.elementRef.nativeElement);
  }

  
  // ngOnDestroy() {
  //   // if this.observer exists and not is disconnected
  //   if(this.observer) {
  //     this.observer.disconnect();
  //   }
  // }
}




@Directive({
  selector: '[scrollInViewport]'
})
export class ScrollInViewportDirective {
  @Input() center: boolean = false;
  @Input() distance: number = 0;// Percentuale da 0 a 100 di distanza dal top di pagina
  @Output() inViewport: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private el: ElementRef) {
   
   }
  
  // return this.viewport.emit true if window loaded sze is less than 1024px
  
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (this.isInViewport()) {
      this.inViewport.emit(true);
    }
  }

  @HostListener('window:touchmove', ['$event'])
  onTouchMove(event: TouchEvent) {
  // Check if element is in viewport when touch move event occurs
  if (this.isInViewport()) {
    this.inViewport.emit(true);
  }
}

  private isInViewport(): boolean {
    const rect = this.el.nativeElement.getBoundingClientRect();
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

    if ('ontouchstart' in window) {
      const elementCenter = {
        x: rect.left + rect.width / 2,
        y: rect.top + rect.height / 2
      };
  
      const touchY = window.scrollY + windowHeight / 2;
      const touchX = window.scrollX + windowWidth / 2;
  
      return (
        elementCenter.y >= touchY - rect.height / 2 &&
        elementCenter.y <= touchY + rect.height / 2 &&
        elementCenter.x >= touchX - rect.width / 2 &&
        elementCenter.x <= touchX + rect.width / 2
      );
    } else {

      if (this.center) {
        const elementCenter = {
          x: rect.left + rect.width / 2,
          y: rect.top + rect.height / 2
        };

        return (
          elementCenter.y >= windowHeight / 2 - rect.height / 2 &&
          elementCenter.y <= windowHeight / 2 + rect.height / 2 &&
          elementCenter.x >= windowWidth / 2 - rect.width / 2 &&
          elementCenter.x <= windowWidth / 2 + rect.width / 2
        );
      }
      else if (this.distance > 0) {
        const windowHeight = (window.innerHeight || document.documentElement.clientHeight);

        // Calcola la posizione del trigger in base alla percentuale
        const triggerPoint = windowHeight * (this.distance / 100);
  
        return (
          rect.top <= triggerPoint &&
          rect.bottom >= triggerPoint
        );
      }
      else {
        return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= windowHeight &&
          rect.right <= windowWidth
        );
      }
    }
  }
}